type ConfirmModalTitleProps = {
  address?: string;
};

export function confirmModalTitle(address: ConfirmModalTitleProps['address']) {
  // If address is entered, show title as 'Confirm your new address'
  if (address) {
    return 'Confirm your new address';
  }

  return 'Confirm your moving day';
}
